import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  // Property to store the VIN info from the URL
  vinFromURL!: string | null;

  constructor(private readonly authService: AuthService) {
    this.vinFromURL = sessionStorage.getItem('vinFromURL');
  }

  public initialize(): void {
    this.authService.initialize();
  }

  public handleRedirect(): Observable<boolean> {
    return this.authService.handleRedirect().pipe(map(() => true));
  }

  public login(forcePrompt = false): void {
    this.authService.login(forcePrompt);
  }

  public logout(): void {
    this.authService.logout();
  }

  public logoutBroadcastReceived(): void {
    this.authService.logoutBroadcastReceived();
  }

  public isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  public setUserDetails(): void {
    this.authService.setUserDetails();
  }

  // Legacy no-op: session checks are handled by silent token renewal in MSAL.
  public checkSessionExpiration(): void {
    return;
  }

  //method to set the VIN from the URL
  public setVinFromURL(vin: string | null) {
    this.vinFromURL = vin;
    if (vin) {
      sessionStorage.setItem('vinFromURL', vin);
    }
  }

  //method to get the VIN from the URL
  public getVinFromURL() {
    return this.vinFromURL || sessionStorage.getItem('vinFromURL');
  }

  //method to clear VIN from session storage
  public clearVinFromURL(): void {
    sessionStorage.removeItem('vinFromURL');
    this.vinFromURL = null;
  }
}
